import styled from 'styled-components';
import { AuthStepWrapper } from '@/bundle/Auth/ui/AuthStep/styles';
import { media } from '@/styles/responsive';

export const SignUpFormWrapper = styled(AuthStepWrapper)`
  padding: 32px;

  ${media.mobile`
    margin-top: 0px;
    padding: 16px;
  `}
`;
